
export function buildAlternativesConnectorProviderConfigQueryV1(organizationUnitId: string, workspaceId: any, projectId: any, viewId: any, attributesIds: any)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativesConnectorProviderConfigQueryV1, TCh.Domain.Alternatives',
		'OrganizationUnitId': organizationUnitId,
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'ViewId': viewId,
		'AttributesIds': attributesIds,
	}
}

export function buildAlternativesByViewDefIdQueryV1(workspaceId: number, projectId: number, viewDefId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativesByViewDefIdQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'ViewDefId': viewDefId
	}
}

export function buildDependencyDialogAlternativesQueryV1(workspaceId: number, projectId: number, alternativeId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.DependencyDialogAlternativesQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativeId': alternativeId,
	}
}

export function buildAlternativeQueryV1(workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, includeAttributeValues: boolean)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativeQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'Id': alternativeId,
		'IncludeAttributeValues': includeAttributeValues
	}
}


export function buildAlternativeDashboardQueryV1(workspaceId: number, projectId: number, alternativeId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativeDashboardQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativeId': alternativeId,
	}
}

export function buildAlternativeLogsQueryV1(workspaceId: number, projectId: number, alternativeId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativeLogsQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativeId': alternativeId,
	}
}

export function buildAlternativeLogEntryQueryV1(workspaceId: number, alternativeId: string, activityLogEntryId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativeLogEntryQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'AlternativeId': alternativeId,
		'ActivityLogEntryId': activityLogEntryId,
	}
}

export function buildLastAlternativeLogEntryQueryV1(workspaceId: number, projectId: number, alternativeId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.LastAlternativeLogEntryQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativeId': alternativeId,
	}
}



export function buildAlternativeAttachmentsQueryV1(workspaceId: number, projectId: number, alternativeId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativeAttachmentsQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativeId': alternativeId,
	}
}

export function buildAlternativeAttachmentQueryV1(workspaceId: number, alternativeId: string, attachmentId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativeAttachmentQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'AlternativeId': alternativeId,
		'AttachmentId': attachmentId,
	}
}


export function buildImportAlternativesPageQueryV1(workspaceId: number, projectId: number, alternativesListId: number, blobId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.ImportAlternativesPageQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'BlobId': blobId
	}
}

export function buildEditAlternativePageQueryV1(alternativeId: string, formId: number | null)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.EditAlternativePageQueryV1, TCh.Domain.Alternatives',
		'AlternativeId': alternativeId,
		'FormId': formId
	}
}


export function buildAlternativeEditorPreviewQueryV1(workspaceId: number, projectId: number, alternativesListId: number, formDefId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativeEditorPreviewQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'FormDefId': formDefId
	}
}

export function buildAlternativeEditorCreationQueryV1(workspaceId: number, projectId: number, alternativesListId: number, formDefId: number | null)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativeEditorCreationQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'FormDefId': formDefId
	}
}

export function buildAlternativeEditorEditionQueryV1(workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, formDefId: number | null)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Alternatives.Queries.AlternativeEditorEditionQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'AlternativeId': alternativeId,
		'FormDefId': formDefId
	}
}




